import { API_BASE_URL, reportEvents } from './api';

// 行为埋点:攒一小批再发,页面被关/切走时用 keepalive 兜底发出去。
// 埋点是旁路,任何失败都静默吞掉,绝不能影响孩子玩。
// 事件名必须在后端白名单里(routes/events.py),清单见 docs/analytics-events.md。

const FLUSH_DELAY_MS = 3000;
const MAX_BATCH = 20;
const STATE_KEY = 'huaxia_quest_state';

let queue = [];
let timer = null;

function currentSessionId() {
  try {
    return JSON.parse(window.localStorage.getItem(STATE_KEY))?.sessionId ?? null;
  } catch {
    return null;
  }
}

export function track(name, props) {
  try {
    queue.push({
      name,
      sessionId: currentSessionId(),
      props: props ?? null,
      clientTs: new Date().toISOString(),
    });
    if (queue.length >= MAX_BATCH) {
      flush();
    } else if (!timer) {
      timer = setTimeout(flush, FLUSH_DELAY_MS);
    }
  } catch {
    // ignore
  }
}

export function flush({ keepalive = false } = {}) {
  clearTimeout(timer);
  timer = null;
  if (queue.length === 0) return;
  const batch = queue.slice(0, MAX_BATCH);
  queue = queue.slice(MAX_BATCH);
  try {
    if (keepalive && typeof fetch === 'function') {
      fetch(`${API_BASE_URL}/api/v1/events`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events: batch }),
        keepalive: true,
      }).catch(() => {});
    } else {
      Promise.resolve(reportEvents(batch)).catch(() => {});
    }
  } catch {
    // ignore
  }
  if (queue.length) flush({ keepalive });
}

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => flush({ keepalive: true }));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush({ keepalive: true });
  });
}

// 仅测试用
export function _resetForTest() {
  clearTimeout(timer);
  timer = null;
  queue = [];
}
